import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { PermissoesService } from '../../shared/services/permissions.service';

export const permissionGuard: CanActivateFn = route => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }

  const required = route.data?.['module'] as string | undefined;
  if (!required) {
    return true;
  }

  const permissoes = inject(PermissoesService);
  if (permissoes.hasPermission(required)) {
    return true;
  }

  const router = inject(Router);
  const toastr = inject(ToastrService);
  const translate = inject(TranslateService);

  const translated = translate.instant('ERRORS.FORBIDDEN');
  toastr.error(
    translated !== 'ERRORS.FORBIDDEN'
      ? translated
      : 'Você não tem permissão para acessar esta tela.'
  );

  return router.createUrlTree(['/auth/dashboard']);
};
